export default "__VITE_ASSET__C9qG5QcA__"